var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bl-no-data"},[_c('el-empty',{attrs:{"description":_vm.$t('common.noData') || _vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }